import { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { MagnifyingGlass, ArrowRight, File } from "@phosphor-icons/react";
import { MODULES_REGISTRY } from "@/pages/modules/registry";

export default function ModulesPage() {
  useDocumentTitle("Moduli");
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    const query = q.trim().toLowerCase();
    if (!query) return MODULES_REGISTRY;
    return MODULES_REGISTRY.filter((m) => {
      const hay = `${m.title} ${m.description} ${m.category} ${(m.keywords || []).join(" ")}`.toLowerCase();
      return hay.includes(query);
    });
  }, [q]);

  return (
    <div className="p-6 lg:p-10 max-w-5xl mx-auto" data-testid="modules-page">
      <header className="mb-8">
        <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-2">// STAMPE PREFATTE</div>
        <h1 className="text-4xl font-display font-bold tracking-tight flex items-center gap-3">
          <File size={30} weight="duotone" className="text-primary" />
          Moduli
        </h1>
        <p className="text-muted-foreground mt-2">
          Genera stampe prefatte con carta intestata Diotech. Seleziona il cliente, compila i dati e scarica/stampa/invia via email. I moduli non vengono salvati.
        </p>
      </header>

      <Card className="p-4 border-border/70 rounded-lg mb-4">
        <div className="relative">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="Cerca modulo…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="pl-9"
            data-testid="modules-search"
          />
        </div>
      </Card>

      {filtered.length === 0 ? (
        <div className="text-center text-muted-foreground py-8">Nessun modulo trovato</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((m) => (
            <Link to={m.to} key={m.id} data-testid={`module-${m.id}`} className="block">
              <Card className="p-5 border-border/70 rounded-lg hover:shadow-md hover:-translate-y-0.5 h-full"
                    style={{ transition: "transform 0.2s ease, box-shadow 0.2s ease" }}>
                <div className="flex items-start gap-3">
                  <div className="h-10 w-10 shrink-0 rounded-full bg-primary/10 text-primary grid place-items-center">
                    <m.icon size={20} weight="duotone" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <div className="font-display font-bold tracking-tight">{m.title}</div>
                      <ArrowRight size={14} className="text-muted-foreground mt-1 shrink-0" />
                    </div>
                    <Badge className="bg-secondary text-foreground border-border hover:bg-secondary font-mono text-[9px] uppercase mt-1">{m.category}</Badge>
                    <div className="text-xs text-muted-foreground mt-2 leading-relaxed">{m.description}</div>
                  </div>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
